import React from 'react';
import { GDSStyleObject, styled } from '../../theme';

export interface GDSIconEmojiProps {
  children: React.ReactNode;
  className?: string;
  css?: GDSStyleObject;
  label?: string;
}

const Emoji = styled('span');

export const IconEmoji = ({
  label,
  children,
  css,
  className,
  ...props
}: GDSIconEmojiProps) => {
  if (!label) {
    console.error(
      "IconEmoji is missing a descriptive label. To be accessible, [role='img'] elements must have an alternative text.",
    );
  }

  return (
    <Emoji
      className={className}
      css={{ display: 'inline-flex', font: 'inherit', ...css }}
      role="img"
      aria-label={label}
      aria-hidden={!label}
      {...props}
    >
      {children}
    </Emoji>
  );
};
